import { useQuery } from '@tanstack/react-query'

import { getServerLikesActive } from '@wwt/core/admin'

import { likeIdsOptions } from '../options/likeIdsOptions'

export const useLikeIds = (options?: Parameters<typeof likeIdsOptions>[0]) => {
	const query = useQuery(
		likeIdsOptions({
			...options,
			enabled: getServerLikesActive() && (options?.enabled ?? true),

			staleTime: 30 * 1000 // 30s
		})
	)

	return query
}
